import backendConfig from '../../../backend/src/config'

const config = {
  ...backendConfig,
  // Add frontend own specific config here
}

export default config
